import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RecurringEpComponent } from './components/recurring-ep/recurring-ep.component';
import { RecurringMultiYearTaxAdjustmentComponent } from './components/recurring-multi-year-tax-adjustment/recurring-multi-year-tax-adjustment.component';
import { RecurringEpService } from './services/recurring-ep.service';
import { RecurringMultiYearTaxAdjustmentService } from './services/recurring-multi-year-tax-adjustment.service';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';

@NgModule({
    declarations: [
        RecurringEpComponent,
        RecurringMultiYearTaxAdjustmentComponent
    ],
    exports: [
        RecurringEpComponent,
        RecurringMultiYearTaxAdjustmentComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        GtwSearchableSelectModule
    ],
    providers: [
        RecurringEpService,
        RecurringMultiYearTaxAdjustmentService
    ]
})
export class RecurringEpModule { }

